import {
  TRemoteDeploymentCheck,
  TRemoteDeploymentDB,
  TRemoteDeploymentStore,
  TRESPONSE_APP_MASTER,
} from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum RemoteDeploymentStoreActionTypes {
  CheckForAppUpdates = 'CheckForAppUpdates',
  UpdateRemoteDeploymentState = 'UpdateRemoteDeploymentState',
  SetRemoteDeploymentState = 'SetRemoteDeploymentState',
  ReFetchAppMasterAndClearState = 'ReFetchAppMasterAndClearState',
  UpdateAppMasterAndClearState = 'UpdateAppMasterAndClearState',
  NoRemoteDeploymentAction = 'NoRemoteDeploymentAction',
  ClearRemoteDeploymentState = 'ClearRemoteDeploymentState',
}

export class NoRemoteDeploymentAction implements Action {
  readonly type = RemoteDeploymentStoreActionTypes.NoRemoteDeploymentAction;
  constructor() {}
}

export class UpdateRemoteDeploymentState implements Action {
  readonly type = RemoteDeploymentStoreActionTypes.UpdateRemoteDeploymentState;
  constructor(public remoteDeploymentDB: TRemoteDeploymentDB, public remoteDeploymentCheck: TRemoteDeploymentCheck) {}
}

export class SetRemoteDeploymentState implements Action {
  readonly type = RemoteDeploymentStoreActionTypes.SetRemoteDeploymentState;
  constructor(public remoteDeploymentDB: TRemoteDeploymentDB) {}
}
export class ClearRemoteDeploymentState implements Action {
  readonly type = RemoteDeploymentStoreActionTypes.ClearRemoteDeploymentState;
  constructor() {}
}

export class CheckForAppUpdates implements Action {
  readonly type = RemoteDeploymentStoreActionTypes.CheckForAppUpdates;
  constructor(public remoteDeploymentCheck: TRemoteDeploymentCheck) {}
}

export class ReFetchAppMasterAndClearState implements Action {
  readonly type = RemoteDeploymentStoreActionTypes.ReFetchAppMasterAndClearState;
  constructor(public remoteDeploymentCheck: TRemoteDeploymentCheck) {}
}

export class UpdateAppMasterAndClearState implements Action {
  readonly type = RemoteDeploymentStoreActionTypes.UpdateAppMasterAndClearState;
  constructor(public remoteDeploymentCheck: TRemoteDeploymentCheck, public newAppMaster: TRESPONSE_APP_MASTER) {}
}

export type TRemoteDeploymentStoreActions =
  | UpdateRemoteDeploymentState
  | ClearRemoteDeploymentState
  | SetRemoteDeploymentState;
